export const data = [
    {
        poster: 'https://cdn.cloudflare.steamstatic.com/steam/apps/2372400/ss_d2d05dbbfdb5dfe16513dcc4f1e4fd6eaa83a1b8.1920x1080.jpg?t=1714571341',
        video: 'https://github.com/Ducklings-Studio/website-ducklings-studio/raw/main/src/assets/video/1.mp4',
    },
]